<template>
	<type-wrapper class="type-Footer" regular>
		<type-grid :row="showData.data.length" margin v-for="(items, index) in showData.data" :key="index">
			<!-- <type-text class="pointer" type="content" size="6" v-hover="{ color: themeColor }" @click="items.isShow = !items.isShow" v-if="items.title">{{ items.title }}</type-text> -->
			<type-text class="pointer" type="content" size="3" v-hover="{ color: themeColor }" @click="jumpAction(items)" v-if="items.title">{{ items.title }}</type-text>

			<transition name="slide" appear>
				<div class="type-Footer-block" v-show="items.isShow" v-if="items.data.length">
					<type-text class="pointer" type="content" size="9" v-hover="{ color: themeColor }" :style="contentColor" @click="jumpAction(item)" v-for="(item, i) in items.data">{{ item.title }}</type-text>
				</div>
			</transition>
		</type-grid>
	</type-wrapper>
</template>

<script>
	// 尾部导航栏
	import mixin from '../mixin.js'
	export default {
		name: 'type-Footer',
		mixins: [ mixin ]
	}
</script>

<style scoped lang="less">
	.type-Footer{
		display: flex;
		flex-wrap: wrap;
		.pointer{
			cursor: pointer;
		}
		.type-Footer-block{
			overflow: hidden;
		}
		.slide-enter-active{
		    opacity: 0;
		    transform: translateY(50%);
		    animation: slide-enter 700ms forwards;
		}
		@keyframes slide-enter{
			from{
				opacity: 0;
				transform: translateY(50%);
			}
			to{
				opacity: 1;
				transform: translateY(0%);
			}
		}
		.slide-leave-active{
			opacity: 1;
			max-height: 500px;
			animation: slide-leave 300ms forwards;
		}
		@keyframes slide-leave{
			from{
				opacity: 1;
				max-height: 500px;
			}
			to{
				opacity: 0;
				max-height: 0;
			}
		}
	}
</style>
